export const NotificationsActions = {
	GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
	READ_NOTIFICATIONS: 'READ_NOTIFICATIONS',
};
